module.exports = __webpack_public_path__ + "images/emoji/non-potable_water.2e6dc5c4a5c17c426269.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/non-potable_water.png
// module id = FELL
// module chunks = 24